$(document).ready(function(e) {
$('.navbar-toggler').on('click', function(e) {
$('body').toggleClass('nav-open');
e.stopPropagation();
});

$('.video-control').on('click', function(e) {
$('.visual-block').toggleClass('remove-mask');
});
});

// below function is to remove class from body clicking anywhere (it is optional)
$(document).click(function(e) {
$('body').removeClass('nav-open');
});

$('#navbar').click(function(e) {
e.stopPropagation();
});

jQuery(document).ready(function(e) {
jQuery('.navbar .nav-link').on('click', function(e) {
    jQuery('body').removeClass('nav-open');
});
});

// SubMenu dropdown on click
    let windowsizer = jQuery(window).width();
    jQuery('.navbar-nav li.dropdown ').on('click', function(e){
        e.stopPropagation();
        jQuery(this).toggleClass('current');
        jQuery(this).siblings().removeClass('current');
    });

    jQuery(".navbar-nav li.dropdown .dropdown-menu").click(function(e){
        e.stopPropagation();
    });

    jQuery(document).click(function (e) {
        
        jQuery(".navbar-nav li.dropdown").removeClass("current");
    });

// Search bar JS
  jQuery(document).ready(function(e) {
  jQuery('#search-oppener').on('click', function(e) {
  jQuery('body').toggleClass('search-active');
  e.stopPropagation();
  });
  jQuery('#header .form-slide').click(function(e){
  e.stopPropagation();
  });
  jQuery(document).on('click', function(e) {
      jQuery('body').removeClass('search-active');
  });
  });

 // Product Slider
 $('.product-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.thumbnail-nav'
});
$('.thumbnail-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.product-for',
  dots: false,
  focusOnSelect: true
});

// ZOOM
$('.ex1').zoom();

// Related product Slider
$('.related-product-slideshow').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
      }
    }
    ]
});